<template>
  <my-modal
    :title="modalTit"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :centered="true"
    :footer="false"
  >
    <h3>{{ $t('message["780"]') }}：</h3>
    <div slot="content">
      <cube-form
        :model="model"
        @submit.prevent="submitHandler"
        @validate="validateHandler"
      >
        <cube-form-group>
          <cube-form-item :field="fields[0]" />
        </cube-form-group>
        <cube-form-group class="cube-picker-footer footer">
          <cube-button
            type="reset"
            class="cancel-btn"
            @click="handleCancel"
          >
            {{ $t('message["896"]') }}
          </cube-button>
          <cube-button
            type="submit"
            class="confirm-btn"
          >
            {{ $t('message["915"]') }}
          </cube-button>
        </cube-form-group>
      </cube-form>
    </div>
  </my-modal>
</template>

<script>
import { inquiryReject } from '@/services/inqueryServices'
import MyModal from '@/components/mobile/Modal'

const FROM_SOPURCE = 'notice'

export default {
  components: {
    MyModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    inquiryId: {
      type: [String, Number],
      default: () => { }
    },
    auditRoleid: {
      type: [String, Number],
      default: () => { }
    },
    auditGroupid: {
      type: [String, Number],
      default: () => { }
    }
  },
  data () {
    return {
      confirmLoading: false,
      model: {
        reason: ''
      },
      fields: [
        {
          type: 'textarea',
          modelKey: 'reason',
          label: '',
          props: {
            indicator: false,
            maxlength: 200000,
            autoExpand: true,
            placeholder: this.$t('message["780"]')
          },
          rules: {
            required: true
          },
          messages: {
            required: this.$t('message["780"]')
          }
        }
      ]
    }
  },
  computed: {
    from () { // all, my, audit, checkrepeat
      return this.$route.query.from
    },
    type () {
      return this.$route.query.type
    },
    modalTit () {
      return this.$t('message["542"]')
    }
  },
  created () {
  },
  methods: {
    hide () {
      this.$emit('update:visible', false)
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
      // console.log('validity', result.validity, result.valid, result.dirty, result.firstInvalidFieldIndex)
    },
    async submitHandler () {
      if (this.confirmLoading) return

      this.confirmLoading = true
      const chain = await inquiryReject()
      chain
        .params({
          inquiryid: parseInt(this.inquiryId),
          reason: this.model.reason,
          audit_roleid: this.auditRoleid,
          audit_groupid: this.auditGroupid
        })
        .onNetSuccess(raw => {
          this.confirmLoading = false
          this.handleCancel()
        })
        .onSuccess(payload => {
          if (this.from === FROM_SOPURCE) {
            this.$router.push({ name: 'recordNotice' })
          } else {
            this.$router.push({
              name: 'InqueryAudit',
              query: {
                type: this.type,
                from: this.from
              }
            })
          }
        })
        .fetch()
    },
    handleCancel () {
      this.hide()
      this.model.reason = ''
      this.confirmLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .cube-picker-panel {
  width: 270px;
  height: auto;
}

::v-deep .cube-form_standard {
  .cube-textarea-wrapper {
    height: 72px;
    padding: 6px;
    border: solid 1px $primary-color;
    border-radius: 4px;
  }
  .cube-textarea-wrapper.cube-textarea_expanded {
    padding: 6px;
  }
  .cube-validator {
    display: block;
  }
  .cube-validator-msg {
    align-items: center;
  }
}
.cube-picker-footer ::v-deep {
  margin-top: 16px;
  height: 50px;
  line-height: 50px;
  border-top: solid 1px #dbdbdb;
  .cube-btn {
    display: inline-block;
    width: 50%;
    padding: 0;
    color: $gray2;
    background-color: #fff;
    border-radius: 0;
    &:first-child {
      border-right: solid 1px #dbdbdb;
    }
    &.confirm-btn {
      color: $primary-color;
    }
  }
}
</style>
